/* Theme-aware ApexCharts chrome colours. Reads the active theme's resolved CSS
 * vars at call time so the charts' axis/grid/legend + light|dark mode follow
 * whatever theme is active (terminal dark, graphite warm-fog, classic light).
 * The per-series data palettes are categorical and intentionally NOT themed. */

function readVar(name: string, fallback: string): string {
  if (typeof window === 'undefined' || typeof document === 'undefined') return fallback;
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v || fallback;
}

/** Rough perceptual luminance 0..1 of a #hex / #rgb / rgb()/rgba() colour. */
function luminance(color: string): number {
  let r = 10, g = 10, b = 10;
  const c = (color || '').trim();
  if (c.startsWith('#')) {
    let h = c.slice(1);
    if (h.length === 3) h = h.split('').map((x) => x + x).join('');
    if (h.length >= 6) { r = parseInt(h.slice(0, 2), 16); g = parseInt(h.slice(2, 4), 16); b = parseInt(h.slice(4, 6), 16); }
  } else {
    const m = c.match(/(\d+)[,\s]+(\d+)[,\s]+(\d+)/);
    if (m) { r = +m[1]; g = +m[2]; b = +m[3]; }
  }
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
}

export interface ChartTheme {
  mode: 'light' | 'dark';
  grid: string;
  axis: string;
  legend: string;
}

export function chartTheme(): ChartTheme {
  const bg = readVar('--bs-body-bg', '#0a0a0a');
  const dark = luminance(bg) < 0.5;
  return {
    mode: dark ? 'dark' : 'light',
    grid: readVar('--bs-border-color', '#1f1f1f'),
    axis: readVar('--bs-tertiary-color', '#6a6a6a'),
    legend: readVar('--bs-secondary-color', '#9a9a9a'),
  };
}
